import { Component, EventEmitter, Input, Output } from "@angular/core";
import { NavItemsSectionConfig, INavItem } from "@webapp/navigation/models/nav-items-list.models";
import { ActiveNavScreenService } from "@webapp/navigation/services/active-nav-screen.service";
import { Ng1StateProxy } from "@gtmhub/core/routing";
import { ItemState, ITEMS_SCREENS_MAP } from "../config";
import { Screens } from "@webapp/navigation/models/shared.models";

@Component({
  selector: "gh-nav-list-item",
  templateUrl: "./nav-list-item.component.html",
  styleUrls: ["./nav-list-item.component.less"],
})
export class NavListItemComponent {
  @Input()
  public config: NavItemsSectionConfig;
  @Input()
  public item: INavItem;
  @Input()
  public itemIsFavorite: boolean;
  @Output()
  public markItemAsFavorite = new EventEmitter<INavItem>();
  @Output()
  public unmarkItemAsFavorite = new EventEmitter<INavItem>();
  public isMenuOpened: boolean;

  constructor(private ng1StateProxy: Ng1StateProxy, private activeNavStateService: ActiveNavScreenService) {}

  private getStateAndScreenKey(item: INavItem): { itemState: ItemState; menuScreenKey: Screens } {
    //in the case where we have a heterogenic container of navitems, we need to find the proper subType and use its state definition to navigate
    const itemScreen = ITEMS_SCREENS_MAP[this.config.itemsType];
    let itemState = itemScreen.itemState;
    let menuScreenKey = itemScreen.menuScreenKey;
    if (!itemState && itemScreen.subTypes) {
      itemState = itemScreen.subTypes[item.uxcType].itemState;
      menuScreenKey = itemScreen.subTypes[item.uxcType].menuScreenKey;
    }
    return { itemState, menuScreenKey };
  }

  public view(item: INavItem): void {
    //?? add debounce if the user clicks the navigation several times
    const { itemState, menuScreenKey } = this.getStateAndScreenKey(item);
    if (itemState) {
      this.activeNavStateService.setNavStateChange(menuScreenKey);
      const params = itemState.paramsMap ? { [itemState.paramsMap.id]: item.id } : {};
      this.ng1StateProxy.go(itemState.name, params);
    }
  }

  public onMenuToggled(value: boolean): void {
    this.isMenuOpened = value;
  }
}
